<template>
    <div>
        <div class="row form-group">
            <div class="col-12">
                <hr />
            </div>
        </div>
        
        <div class="row form-group">
            <div class="col-12">
                <label>{{resource('JourneyBuilder_TimerSettings_Frequency')}}</label>
            </div>
        </div>

        <div class="row form-group">
            <div class="col-6">
                <settings-property>
                    <template #label="{id}">
                        <label :for="id">{{resource('JourneyBuilder_TimerSettings_Frequency_Unit_Label')}}</label>
                    </template>
                    <template #input="{id}">
                        <v-select
                            class="form-control"

                            v-model="unitModel"
                            :options="UNIT_OPTIONS"
                            :disabled="!canWrite"
                            :clearable="false"

                            :input-id="id"

                            searchable
                            filterable
                        />
                    </template>
                    <template #errors>
                        <required-error-message v-if="$v.$dirty && $v.unit.$invalid" />
                    </template>
                </settings-property>
            </div>
        </div>

        <template v-if="unitModel">
            <div class="row form-group">
                <div class="col-6">
                    <settings-property>
                        <template #label="{id}">
                            <label :for="id">{{resource('JourneyBuilder_TimerSettings_Frequency_Recurrence_Label')}}</label>
                        </template>

                        <template #input="{id}">
                            <div class="row">
                                <div class="col-8">
                                    <v-select
                                        class="form-control"

                                        v-model="recursInUnitModel"
                                        :options="unitModel.recurrenceOptions"
                                        :disabled="!canWrite"
                                        :clearable="false"

                                        :input-id="id"
                                        
                                        searchable
                                        filterable
                                    />
                                </div>
                                <div class="col-4">
                                    {{unitModel.recurrenceLabel}}
                                </div>
                            </div>
                        </template>
                        
                        <template #errors>
                            <required-error-message v-if="$v.$dirty && $v.recursInDays.$invalid" />
                        </template>
                    </settings-property>
                </div>
            </div>
        </template>
        
        <template v-if="unitModel === UNITS.WEEKLY">
            <div class="row form-group">
                <div class="col-2">
                    <label>{{resource('JourneyBuilder_TimerSettings_Frequency_Weekday_Label')}}</label>
                </div>

                <div class="col-10">
                    <div class="row">
                        <div v-for="weekday in WEEKDAY_OPTIONS" class="col-4">
                            <input
                                type="checkbox"

                                @input="toggleWeekday(weekday)"
                                :checked="weekdays.includes(weekday.id)"
                                :id="`weekday_${weekday.id}`"
                                
                                :disabled="!canWrite"
                            />

                            <label :for="`weekday_${weekday.id}`">{{weekday.label}}</label>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import { timerFrequencyValidations } from './validations';
import { timerCheckpoint } from "@modules/JourneyBuilder/Bricks/Checkpoints";

import { validationMixin } from 'vuelidate';
import permissionsMixin from "@modules/JourneyBuilder/Mixins/journey-permissions";
import resourceMixin from "@core/Util/Mixins/resources";

import SettingsProperty from "../SettingsProperty";
import VSelect from 'vue-select';
import RequiredErrorMessage from "@core/Components/Errors/RequiredErrorMessage";

const UNITS = timerCheckpoint.FREQUENCY_UNITS;
const WEEKDAYS = timerCheckpoint.FREQUENCY_WEEKDAYS;

const UNIT_OPTIONS = Object.values(UNITS);
const WEEKDAY_OPTIONS = Object.values(WEEKDAYS);

export default {
    name: "BrickTimerFrequencySettings",
    
    mixins: [validationMixin, permissionsMixin, resourceMixin],
    
    components: {
        RequiredErrorMessage,
        SettingsProperty,
        VSelect
    },
    
    props: {
        unit: {
            type: String,
            required: false
        },
        
        recursInDays: {
            type: Number,
            required: false
        },
        
        weekdays: {
            type: Array,
            required: false
        }
    },
    
    data() {
        return {
            UNIT_OPTIONS,
            UNITS,
            WEEKDAY_OPTIONS
        }
    },
    
    computed: {
        unitModel: {
            get() {
                return UNIT_OPTIONS.find(option => option.id === this.unit);
            },
            set(value) {
                this.$emit('update:unit', value.id);
            }
        },
        
        recursInUnitModel: {
            get() {
                if(!this.recursInDays || !this.unitModel) {
                    return undefined;
                }
                
                return this.unitModel.fromDays(this.recursInDays);
            },
            set(value) {
                if(value && this.unitModel) {
                    value = this.unitModel.toDays(value);
                }
                
                this.$emit('update:recursInDays', value);
            }
        }
    },
    
    validations: timerFrequencyValidations,
    
    watch: {
        unitModel(newValue) {
            //Force weekdays to clear for any non-weekly unit
            if(newValue !== UNITS.WEEKLY) {
                this.$emit('update:weekdays', []);
            }
            
            //Reset our recurs in days - prevent accidental funky conversions
            this.$emit('update:recursInDays', undefined);
        }
    },
    
    methods: {
        toggleWeekday(weekday) {
            const modifyableWeekdays = this.weekdays.slice();
            
            const idx = this.weekdays.indexOf(weekday.id);

            if(idx === -1) {
                modifyableWeekdays.push(weekday.id);
            } else {
                modifyableWeekdays.splice(idx, 1);
            }
            
            this.$emit('update:weekdays', modifyableWeekdays);
        },

        displayErrors() {
            this.$v.$touch();
        }
    }
}
</script>
